import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { ContainerOncology } from './styles'
import { FeatureFlag, withDashboardLoader } from '~/components/shared'
import { OncologyContent, OncologyHeader } from '~/components/oncologyMedicalView'
import { useDocumentTitle } from '~/hooks'
import { message } from '~/services'
import { OncologyHealthProceduresProvider, usePatient } from '~/context'
import { SEARCH_PATIENT_PATH } from '~/constants'

const OncologyMedicalViewPage = (): JSX.Element => {
  useDocumentTitle(message('titles.timeline_oncology'))
  const { resetPatientTag } = usePatient()

  useEffect(() => {
    resetPatientTag()
  }, [resetPatientTag])

  return (
    <FeatureFlag flag="OncologyView" fallback={<Navigate to={SEARCH_PATIENT_PATH} />}>
      <OncologyHealthProceduresProvider>
        <ContainerOncology>
          <OncologyHeader />
          <OncologyContent />
        </ContainerOncology>
      </OncologyHealthProceduresProvider>
    </FeatureFlag>
  )
}

export const OncologyMedicalView = withDashboardLoader(OncologyMedicalViewPage)
